import { deleteDoc, doc } from "firebase/firestore";
import Failure from "../../../core/Failure";
import Job from "../../models/Job";
import { FirestoreCollections, firestore } from "../../../firebase.config";

async function deleteJob(
  jobDoc: Job,
): Promise<void> {
  try {
    const jobId = jobDoc.id;
    await deleteDoc(doc(firestore, FirestoreCollections.jobs, jobId));
    return;
  } catch (e) {
    console.log("error: ", e);
    throw new DeleteJobFailure();
  }
}

export class DeleteJobFailure extends Failure {
  constructor(message = "Unknown error", code = "unknown-error") {
    super(message, code);
  }
}

export default deleteJob;
